import React, { useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_RU } from "material-react-table/locales/ru";
import { getEduProgram } from "../../api/Api";
import { columns } from "../../utils/consts/consts";

const DEFAULT_PROGRAM_IDS = [1, 2, 3, 4, 7];

const CostTable = ({ programIds = DEFAULT_PROGRAM_IDS }) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Функция для определения уровня образования
    const getEducationLevel = (propertyType) => {
        const educationLevels = {
            1: "Специалитет",
            2: "Бакалавриат",
            3: "Магистратура",
            4: "Колледж",
            7: "Аспирантура"
        };
        return educationLevels[propertyType] || "Неизвестно";
    };

    // Загрузка данных
    useEffect(() => {
        const fetchCostData = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const apiResponse = await getEduProgram(programIds);

                if (!Array.isArray(apiResponse)) {
                    throw new Error("Некорректный формат данных от сервера");
                }

                const transformedData = apiResponse.map(item => ({
                    article: item.article || "—",
                    name: item.name || "—",
                    execFormName: item.execFormName || "—",
                    educationLevel: getEducationLevel(item.propertyType),
                    price: item.price || 0,
                    paid: item.paid || 0,
                }));

                setData(transformedData);
            } catch (err) {
                console.error("Ошибка при получении данных:", err);
                setError(err.message || "Неизвестная ошибка");
            } finally {
                setIsLoading(false);
            }
        };

        fetchCostData();
    }, [programIds]); // Зависимость от programIds

    if (error) {
        return (
            <div style={{ color: 'red', padding: '16px' }}>
                Ошибка: {error}
                <button
                    onClick={() => window.location.reload()}
                    style={{ marginLeft: '10px' }}
                >
                    Попробовать снова
                </button>
            </div>
        );
    }

    return (
        <div style={{ margin: '16px' }}>
            <MaterialReactTable
                columns={columns}
                data={data}
                state={{ isLoading }}
                enableExpandAll={false}
                filterFromLeafRows={true}
                paginateExpandedRows={false}
                localization={MRT_Localization_RU}
                muiTablePaperProps={{
                    elevation: 0,
                    sx: {
                        borderRadius: "8px",
                        border: "1px solid #e0e0e0",
                        overflow: 'hidden'
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        fontWeight: "bold",
                        backgroundColor: "#f5f5f5",
                        whiteSpace: 'nowrap',
                    },
                }}
                muiTableBodyCellProps={{
                    sx: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }
                }}
            />
        </div>
    );
};

export default CostTable;